import clsx from 'clsx';
import React from 'react';

import { focusRingClassName } from '#/shared/utils/domHelper';

import { FormFieldLabel } from './FormFieldLabel';
import { FormFieldSupportingText } from './FormFieldSupportingText';
import { BaseFormFieldProps } from './types';

type TextInputFieldProps = React.InputHTMLAttributes<HTMLInputElement> &
  BaseFormFieldProps & {
    ref?: React.Ref<HTMLInputElement>;
  };

export const TextInputField = ({
  description,
  descriptionLeadingIconName,
  descriptionPosition = 'below',
  errorMessage,
  errorLeadingIconName,
  className,
  label,

  ...props
}: TextInputFieldProps) => {
  const id = React.useId();
  const inputId = `field-${id}`;
  const labelId = `label-${id}`;
  const descriptionId = `desc-${id}`;
  const errorId = `error-${id}`;

  return (
    <div className={clsx('relative w-full', className)}>
      <FormFieldLabel id={labelId} htmlFor={inputId}>
        {label}
      </FormFieldLabel>

      {description && descriptionPosition === 'above' && (
        <FormFieldSupportingText id={descriptionId} leadingIconName={descriptionLeadingIconName} position="above">
          {description}
        </FormFieldSupportingText>
      )}

      <input
        className={clsx(
          'w-full px-16 py-16 border-1 rounded-xs bg-surface-l0',
          errorMessage ? 'border-error focus:ring-error' : 'border-outline-l4 focus:ring-primary',
          focusRingClassName,
        )}
        id={inputId}
        aria-labelledby={labelId}
        aria-describedby={`${descriptionId} ${errorId}`}
        {...props}
      />

      {description && descriptionPosition === 'below' && (
        <FormFieldSupportingText id={descriptionId} leadingIconName={descriptionLeadingIconName} position="below">
          {description}
        </FormFieldSupportingText>
      )}

      {errorMessage && (
        <FormFieldSupportingText id={errorId} leadingIconName={errorLeadingIconName} isError>
          {errorMessage}
        </FormFieldSupportingText>
      )}
    </div>
  );
};
